var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.clicked}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"20","viewBox":"0 0 13 20"}},[_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#979797","stroke-width":"3","d":"M12 2l-9 8 9 8"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e6592f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/icons/left-component.vue
// module id = 969
// module chunks = 3 24